<div [ngClass]="{'form-layout-compact': useCompactFormLayout}">
  <div class="field">
    <label soho-label>{{'TagsLabel' | translate}}</label>
    <lm-list-dropdown #dynamicBusinessObjectTagComponent
      id="dynamicBusinessObjectTag"
      data-automation-id="lm-add-tag"
      soho-alert
      [options]="dynamicBusinessObjectTagOptions"
    >
    </lm-list-dropdown>
  </div>
</div>